(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
    		'ui.sortable'
    		, 'ngFileUpload'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('InteractiveController', interactive);

  interactive.$inject = ['$scope', '$http', 'Upload', 'LangService', 'FoundationApi', '$state', 'NotificationFactory', 'StatusService'];

  function interactive ($scope, $http, Upload, LangService, FoundationApi, $state, NotificationFactory, StatusService) {
    var vm = this;
    $scope.vm = vm;
    vm.labels = '';

    LangService
      .getPageLabels({ 'page': 'interactive' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

 		var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });
    vm.selectedChannel = null;
    $http.get(apiUrl + '/triggers').then(function (response) {
      vm.channels = response.data;

      if ($state.params.id) {
        angular.forEach(vm.channels, function (channel) {
          if (channel.id == $state.params.id && channel.type == 'App\\Models\\Channels\\WhatsappAPI' || channel.type == 'App\\Models\\Channels\\WhatsappWeb' || channel.type == 'App\\Models\\Channels\\Waent') {
            vm.selectChannel(channel);
          };
        });
      }
    }, function ({ data }) {
      errorHandler(data, vm.labels.errorLoadTriggers);
    })
    StatusService.all()
      .$promise
      .then(function (data) {
        vm.statuses = data;
      }).catch(function (data) {
        errorHandler(data, vm.labels.errorLoadStatus)
      })
    vm.nTrigger = {
      show: false,
      trigger_type: '',
      actions: []
    };

    vm.sortableOptions = {
      containment: '#sortable-container'
    };

    vm.trigger_types = [
      {
        name: 'Selecione o tipo do gatilho',
        value: ''
      },
      {
        name: 'Texto',
        value: 'text'
      },
      {
        name: 'Primeira Mensagem',
        value: 'first_message'
      },
      {
        name: 'Menu',
        value: 'menu'
      },
      {
        name: 'Comando Inválido',
        value: 'invalid_command'
      },
      {
        name: 'Fechar chat',
        value: 'on_chat_close'
      },
      {
        name: 'Notificação de Operadores Offline',
        value: 'offline_operators_notification'
      }
    ];

    vm.selectChannel = selectChannel;
    vm.closeChannel = closeChannel;
    vm.selectTrigger = selectTrigger;
    vm.newTrigger = newTrigger;
    vm.addTriggerAction = addTriggerAction;
    vm.removeTriggerAction = removeTriggerAction;
    vm.closeTrigger = closeTrigger;
    vm.saveTrigger = saveTrigger;
    vm.deleteTrigger = deleteTrigger;
    vm.goToChannel = goToChannel;
    function successHandler (data, override_message) {
      var message = vm.labels.dataSaved;
      if (override_message) {
            	message = override_message
      } else {
            	 if (data) {
	               	if (data.data) {
            if (data.data.message) { message = data.data.message; }
          }
	            }
      }
         	notifSet.addNotification({ title: vm.labels.success, content: message, autoclose: '3000', color: 'success' });
    }
    function errorHandler (data, message) {
      var message = vm.labels.errorTryAgain;
      if (data) {
        if (data.data) {
          if (data.data.message) { message = data.data.message; }
        }
      }
         	notifSet.addNotification({ title: vm.labels.error, content: message, autoclose: '3000', color: 'alert' });
    }
    function goToChannel (channelId) {
      console.log(channelId);
      $state.go('main.interactive-channel', { id: channelId });
    }

    function deleteTrigger (trigger, $index) {
      $http.post(apiUrl + '/triggers/' + trigger.id, { '_method': 'delete' })
        .then(function ({ data }) {
          vm.selectedChannel.triggers.splice($index, 1);
          vm.closeTrigger(vm.channels.indexOf(vm.nTrigger));
          successHandler(data, vm.labels.triggerSaved)
        }, function (error) {
          errorHandler(error, vm.labels.errorDeleteTrigger)
        })
    }

    function addTriggerAction () {
      vm.nTrigger.actions.push({ type: '', params: {} });
    }

    function removeTriggerAction (index) {
      vm.nTrigger.actions.splice(index, 1);
    }

    function closeChannel () {
      vm.selectedChannel = undefined;
      vm.nTrigger.show = false;
    }

    function selectChannel (channel) {
      vm.selectedChannel = channel;
      vm.nTrigger = {
        show: false,
        trigger_type: '',
        actions: []
      };
    }

    function selectTrigger (trigger) {
      vm.nTrigger = angular.copy(trigger);
      vm.nTrigger.show = true;
    }

    function closeTrigger (index) {
      vm.nTrigger = {
	    		show: false,
        trigger_type: '',
        actions: []
		    };
		    $http.get(apiUrl + '/triggers').then(function ({ data }) {
        vm.channels = data;

        if ($state.params.id) {
          angular.forEach(vm.channels, function (channel) {
            if (channel.id == $state.params.id && channel.type == 'App\\Models\\Channels\\WhatsappAPI' || channel.type == 'App\\Models\\Channels\\WhatsappWeb' || channel.type == 'App\\Models\\Channels\\Waent') {
              vm.selectChannel(channel);
            };
          });
        }
      }, function (error) {
        errorHandler(error, vm.labels.errorLoadTriggers);
      })
    }

    function newTrigger () {
      vm.nTrigger = {
	    		show: false,
        trigger_type: '',
        actions: []
		    };
      vm.nTrigger.show = true;
    }

    function saveTrigger () {
      vm.nTrigger;
      if (vm.nTrigger.id) {
        // Updating
        var data = {
          name: vm.nTrigger.name || '',
          description: vm.nTrigger.description || '',
          trigger_text: vm.nTrigger.trigger_text || '',
          actions: vm.nTrigger.actions || [],
          trigger_type: vm.nTrigger.trigger_type || ''
        };
        $http.patch(apiUrl + '/triggers/' + vm.nTrigger.id, data)
          .then(function () {
            var triggers = vm.selectedChannel.triggers;
            var index = triggers.indexOf(triggers.filter(obj => {
              return obj.id === vm.nTrigger.id
					  })[0]
            );

            vm.selectedChannel.triggers[index] = vm.nTrigger;
            vm.closeTrigger(vm.channels.indexOf(vm.nTrigger));
            successHandler(data, vm.labels.triggerSaved)
          }, function ({ data }) {
            errorHandler(data, vm.labels.errorDeleteTrigger)
          })
      } else {
        // Creating
        var data = {
          triggerable_id: vm.selectedChannel.id || '',
          triggerable_type: vm.selectedChannel.type || '',
          name: vm.nTrigger.name || '',
          description: vm.nTrigger.description || '',
          trigger_text: vm.nTrigger.trigger_text || '',
          actions: vm.nTrigger.actions || [],
          trigger_type: vm.nTrigger.trigger_type || ''
        };
        $http.post(apiUrl + '/triggers', data)
          .then(function ({ data }) {
            vm.selectedChannel.triggers.push(data.trigger);
            vm.closeTrigger(vm.channels.indexOf(vm.nTrigger));
            successHandler(data, vm.labels.triggerSaved)
          }, function ({ data }) {
            errorHandler(data, vm.labels.errorDeleteTrigger)
          })
      }
    }

    vm.attachState = 1;
    vm.checkAttaching = function (action, stage) {
      action.temp = action.temp || {};
      if (action.params.image) {
        action.temp.attachState = 3;
      }
      var current = action.temp.attachState || 1;
      if (stage) {
        return current == stage;
      }
      return current > 1;
    }
    vm.cancelAttach = function (action) {
      vm.attachState = 1;
    }
    vm.upload = function (file, action) {
      if (!file) return;

      action.temp.attachState = 2;
      vm.current_progress = 0;
      Upload.upload({
        url: baseUrl + '/channel/trigger_image',
        fields: { 'channel_id': vm.selectedChannel.id, 'channel_type': vm.selectedChannel.type },
        file: file
      }).progress(function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        vm.current_progress = progressPercentage;
      }).then(function (data, status, headers, config) {
        if (data.success) {
          action.temp.attachState = 3;
          // action.temp.url = data.url;
          action.params.image = data.image;
        }
      }, function (data, status, headers, config) {
        errorHandler(data, vm.labels.errorUploadImage)
      })
    };
  }
})();
